<template>
  <div id="app">
    <transition :name="transitionName" mode="out-in">
      <keep-alive :exclude="`ThankYouPage,PolicyPage,LeadValidation`">
        <router-view :key="`page-${$route.path}`" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import objectFitImages from 'object-fit-images'
  import responsive from '@/mixins/responsive'
  import appendScripts from '@/mixins/append-head-body-mixin'

  export default {
    name: 'App',

    mixins: [responsive, appendScripts],

    data () {
      return {
        componentReady: false,
        transitionName: 'slide-to-right'
      }
    },

    watch: {
      $route (to, from) {
        let toDepth = to.path.split('/').length
        let fromDepth = from.path.split('/').length

        toDepth = to.path === '/' ? 0 : toDepth
        fromDepth = from.path === '/' ? 0 : fromDepth

        let goToLeft = toDepth < fromDepth

        if (to.path === '/policy' || to.path === '/thank-you') {
          goToLeft = false
        }

        if (from.path === '/policy' || from.path === '/thank-you') {
          goToLeft = true
        }

        this.transitionName = goToLeft
          ? 'slide-to-left' : 'slide-to-right'

        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      }
    },

    async mounted () {
      await this.fetchGlobalData()

      function inIframe () {
        try {
          return window.self !== window.top
        } catch (e) {
          return true
        }
      }
      if (inIframe()) {
        document.querySelector('html').classList.add('iframe')
      }

      if (this.$route.name !== 'lead-validation' && this.$route.name !== 'certificate') {
        await Promise.all([this.fetchGeneralData(), this.fetchFleetPageData()])
        // this.appendScriptsToHeadAndBody(this.$store.getters.scriptsHeadBody)
      }

      const hasHover = window.matchMedia('(hover: hover)').matches
      if (hasHover) {
        document.documentElement.classList.add('has-hover')
      }

      objectFitImages() // object-fit polyfill

      this.componentReady = true
    },

    methods: {
      // ...mapActions(['fetchGeneralData'])
      ...mapActions(['fetchGlobalData', 'fetchGeneralData', 'fetchFleetPageData'])
    }
  }
</script>

<style lang="scss">
  #app {
    // padding-top: 40px;

    @include mobile {
      padding-top: 15px;
    }
  }
</style>
